import { useEffect } from "react";

interface SpacingOptions {
  selector: string;
  property: "margin" | "padding" | "marginBottom" | "paddingBottom" | "marginTop" | "paddingTop" | "bottom" | "top";
  condition: boolean;
  spacing: number | string;
  mobileSpacing?: number | string;
  mediaQuery?: string;
  defaultSpacing?: number | string;
}

const defaultOptions: Partial<SpacingOptions> = {
  mediaQuery: "(min-width: 768px)",
  property: "paddingBottom",
  mobileSpacing: "100px",
  defaultSpacing: "3rem",
};

export const useElementSpacing = (options: SpacingOptions) => {
  const mergedOptions = { ...defaultOptions, ...options };
  // console.log("useElementSpacing", JSON.stringify(options));

  useEffect(() => {
    const updateSpacing = () => {
      const elements = document.querySelectorAll(mergedOptions.selector);
      const isDesktop = window.matchMedia(mergedOptions.mediaQuery!).matches;
      const currentSpacing = isDesktop ? mergedOptions.spacing : mergedOptions.mobileSpacing || mergedOptions.spacing;

      elements.forEach((element) => {
        if (mergedOptions.condition) {
          (element as HTMLElement).style[mergedOptions.property] =
            typeof currentSpacing === "number" ? `${currentSpacing}px` : currentSpacing;
        } else {
          (element as HTMLElement).style[mergedOptions.property] = mergedOptions.defaultSpacing.toString() || "0";
        }
      });
    };

    updateSpacing();

    const mediaQueryList = window.matchMedia(mergedOptions.mediaQuery!);
    mediaQueryList.addEventListener("change", updateSpacing);
    window.addEventListener("resize", updateSpacing);

    return () => {
      mediaQueryList.removeEventListener("change", updateSpacing);
      window.removeEventListener("resize", updateSpacing);
      document.querySelectorAll(mergedOptions.selector).forEach((element) => {
        (element as HTMLElement).style[mergedOptions.property] = mergedOptions.defaultSpacing.toString() || "0";
      });
    };
  }, [mergedOptions]);
};
